import React, {Component} from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import PieChart from 'react-minimal-pie-chart';
import jQuery from 'jquery';

const $ = window && window.jQuery ? window.jQuery : jQuery;


class OfficialTest extends Component {
    constructor(props){
        super(props);
        this.state = {
            name: '',
            courseId: '',
            id: '',
            profileId: '',
            minScore: 0,
            maxScore: 0,
            testDate: '',
            score: 0,
            scored: false,
            sections: [
            ]
        }
    }
    
    componentDidUpdate(props, state){
        if(state.courseId !== this.state.courseId && this.state.courseId !== ""){
            if(this.state.courseId === "custom"){
                this.setState({sections: [{name: '', minScore: '', score: '', maxScore: ''}]});
            }else{
                this.setTestTemplate();
            }
        }
    }
    
    setTestTemplate = () => {
        if(this.props.courses.filter(c => c.id === this.state.courseId).length > 0){
                let course = this.props.courses.filter(c => c.id === this.state.courseId)[0];
                if(course.officialTest){
                    if(course.officialTest.sections.length > 0){
                        this.setState({sections: course.officialTest.sections});
                    }
                }
            }
        
    }
    
    MoveScrollArea = (e, scrType, i) => {
        if(scrType=="left"){
            $('.diagnostic-score-wrapper')[i].animate({
                scrollLeft: "-=500px"
            }, "slow");

        }else{
            $('.diagnostic-score-wrapper')[i].animate({
                scrollLeft: "+=500px"
            }, "slow");

        }
        e.preventDefault();
    }
    
    saveTest = () => {
        let newTest = {
            name: this.state.name,
            courseId: this.state.courseId,
            profileId: this.props.profileId,
            minScore: this.state.minScore,
            maxScore: this.state.maxScore,
            score: this.state.score,
            testDate: this.state.testDate,
            scored: this.state.scored,
            sections: this.state.sections,
            id: this.state.id
        }
        
        this.props.addOfficialTest(newTest);
    }
    
    
    updateOfficialTestSection = (key, val, i) => {
        let {sections} = this.state;
        sections[i][key] = val;
        this.setState({sections});

    }
    
    addOfficialTestSection = () => {
        let {sections} = this.state;
        sections.push({name: '', minScore: '', maxScore: '', score: ''});
        this.setState({sections});
    }
    
    removeOfficialTestSection = (i) => {
        let {sections} = this.state;
        sections.splice(i, 1);
        this.setState({sections});
    }
    
    
    renderCustomTest = () => {
        return (
            <div>
            {this.state.sections.length > 0 &&
                this.state.sections.map((section, sectioni) => {
                    return (
                        <div className="row" key={sectioni}>
                           
                            <div className="col-sm-12">
                                <div className="section-names-and-placholder-texts">
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <input type="text" placeholder="Section Name" className="form-control" value={this.state.sections[sectioni].name || ''} onChange={e => this.updateOfficialTestSection('name', e.target.value, sectioni)} />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <div className="input-group">
                                                    <input type="text" className="form-control" placeholder="Score" value={this.state.sections[sectioni].score || ''} onChange={e => this.updateOfficialTestSection('score', e.target.value, sectioni)} />
                                                    <div className="input-group-addon">Out of</div>
                                                    <input type="text" className="form-control" placeholder="Max Score" value={this.state.sections[sectioni].maxScore || ''} onChange={e => this.updateOfficialTestSection('maxScore', e.target.value, sectioni)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            {sectioni === 0 ?
                                            <a href="#" className="btn btn-default btn-icon btn-icon-44" data-toggle="tooltip" data-trigger="hover" title="Add Another Section Info" onClick={e => this.addOfficialTestSection()}>
                                                <i className="fa fa-plus-circle"></i> 
                                            </a>
                                            :
                                            <a href="#" className="btn btn-default btn-icon btn-icon-44" data-toggle="tooltip" data-trigger="hover" title="Remove Section Info" onClick={e => this.removeOfficialTestSection(sectioni)}>
                                                <i className="fa fa-minus-circle"></i> 
                                            </a>
                                            }
                                        </div>
                                    </div>
                                </div>
                                

                            </div>
                            
                            
                            
                        </div>
                            
                    )
                })
                } 
                </div>
        )
    }
    
    renderSingleTest = (test, i) => {
        return (
            <div className="foundationDiagnosticDivision sm-bottom10" style={{background: "#2d2d2d"}}>
                <div className="sp-top0">
                    <table className="table profile-info-table" style={{border: "none !important", background: "#272727"}}>
                        <tbody><tr>
                            <td style={{paddingLeft: "20px"}}>
                                <p>Course</p>
                                <h3 className="text-white">{test.name || test.Course ? test.Course.name : test.name}</h3>
                            </td>
                            <td style={{width: "240px"}}>
                                <p>Official Test Date</p>
                                <h3>{moment(test.testDate).format('MMM DD YYYY')}</h3>
                            </td>
                            <td>
                                <p>Official Test Score</p>
                                <h3>{test.score}</h3>
                            </td>

                            <td style={{width: "40px"}} className="text-center">
                                <div className="dropdown">
                                    <a href="#" className="btn MoreBtn font-20" data-toggle="dropdown"><i className="zmdi zmdi-more-vert"></i> </a>
                                    <ul className="dropdown-menu pull-right">
                                        <li><a href="#" data-toggle="collapse" data-target={`#collapseTest-${test.id}`} aria-expanded="false" aria-controls={`collapseTest-${test.id}`}>Expand</a> </li>
                                        <li><a href="#AddTestTakenModal" data-toggle="modal" onClick={e => {
                                            this.setState({
                                                name: test.name,
                                                testDate: test.testDate,
                                                sections: test.sections,
                                                score: test.score,
                                                scored: test.scored,
                                                courseId: test.courseId,
                                                id: test.id
                                            })
                                        }}>Edit</a> </li>
                                        <li><a href="#" onClick={e => {
                                            e.preventDefault();
                                            this.props.deleteOfficialTest(test.Id);
                                        }}>Delete</a> </li>
                                    </ul>
                                </div>
                            </td>

                        </tr>
                    </tbody></table>
                </div>
                <div className="sm-top0 daignosticscores collapse" id={`collapseTest-${test.id}`}>
                    <div className="panel-heading" style={{background: "#2d2d2d"}}>
                        <div className="flex flex-justify-content-space-between flex-align-items-center">
                            <h3 className="panel-title text-uppercase">Diagnostic Scores</h3>
                            <div>

                                <div className="btn-group">
                                    <a href="#" className="btn btn-default" onClick={e => this.MoveScrollArea(e, 'left', i)}><i className="zmdi zmdi-chevron-left"></i> </a>
                                    <a href="#" className="btn btn-default" onClick={e => this.MoveScrollArea(e, 'right', i)}><i className="zmdi zmdi-chevron-right"></i> </a>
                                </div>

                                <div className="btn-group">
                                    <a href="#" className="btn btn-primary" data-toggle="collapse" data-target={`#collapseTest-${test.id}`} aria-expanded="false" aria-controls={`collapseTest-${test.id}`}><i className="zmdi zmdi-close"></i> </a>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="clearfix diagnostic-score-wrapper">
                        <div className="one-fifth text-center sp-20 diagnostic-score sectionsScore">
                            <p>Sections</p>
                        </div>
                        {test.sections.length > 0 &&
                            test.sections.map((section, sectionIndex) => {
                                return (
                                    <div key={sectionIndex} className="one-fifth text-center sp-20 diagnostic-score" style={{position: "relative"}}>
                                        <p>{section.name}</p>
                                        <PieChart
                                            style={{width: 100, margin: '0 auto'}}
                                            data={[
                                                {value: 100, color: '#222'},
                                                {value: (section.score / section.maxScore) * 100, color: '#e33339'}
                                            ]}
                                            totalValue={100}
                                            lineWidth={10}
                                            startAngle={-90}
                                            rounded={true}
                                        />
                                        <p className="diagnostic-pie-chart-counter">{section.score}/{section.maxScore}</p>
                                    </div>     
                                    
                              
                                )
                            })
                        }
                        
                    </div>

                </div>
            </div>
        )
    }
    
    renderTemplateSection = (section, i) => {
        return (
            <div className="row" key={i}>
                <div className="col-sm-4">
                    <p className="sp-top10 text-right">
                        {section.name}
                    </p>
                </div>
                <div className="col-sm-6">
                    <div className="input-group">
                        <input type="number" className="form-control" placeholder="e.g 126" aria-invalid="false" value={section.score} onChange={e => {
                            let {sections} = this.state;
                            sections[i].score = e.target.value;
                            this.setState({sections});
                        }} />
                        <div className="input-group-addon">out of</div>
                        <input type="number" className="form-control disabled" disable={true} value={section.maxScore} placeholder="e.g 132" />
                    </div>
                </div>
            </div>    
        )
    }
    
    render(){
        return (
            <div className="panel customPanel">
                    <div className="panel-heading">
                        <div className="panel-control">
                            <a href="#AddTestTakenModal" data-toggle="modal" style={{position: "relative", top: "5px", color: "#777"}} onClick={e => {
                                this.setState({name: '', id: '', sections: [], testDate: '', courseId: ''});
                            }}> <i className="zmdi zmdi-plus font-30"></i> </a>
                        </div>
                        <h3 className="panel-title text-uppercase"><i className="zmdi zmdi-account sm-right20"></i> Update Tests Taken</h3>
                    </div>
                    <div className="panel-body">
                                                
                        {this.props.tests.length > 0 ?
                            this.props.tests.map((t, i) => this.renderSingleTest(t, i)) 
                        : null}
                        
                    </div>
                    <div className="panel-footer text-right">
                        <input type="submit" className="btn btn-primary w-100" value="Save" />
                    </div>
                    <div className="modal fade" id="AddTestTakenModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                                    <h4 className="modal-title" id="myModalLabel">Add Test Taken</h4>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <p className="sp-top10 text-right">
                                                    Test Type
                                                </p>
                                            </div>
                                            <div className="col-sm-6">
                                                <select className="form-control" value={this.state.courseId} onChange={e => this.setState({courseId: e.target.value})}>
                                                    <option value="">Choose</option>
                                                    {this.props.courses.map((c, i) => {
                                                        return (
                                                            <option key={i} value={c.id}>{c.name}</option>
                                                        )
                                                    })}
                                                    <option value="custom">Custom</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <p className="sp-top10 text-right">
                                                    Date Test Taken
                                                </p>
                                            </div>
                                            <div className="col-sm-6">
                                                
                                                <DatePicker
                                                    selected={this.state.testDate ? moment(this.state.testDate) : moment()}
                                                    name={"testDate"}
                                                    className="form-control"
                                                    onChange={e => this.setState({testDate: e})}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    yearDropdownItemNumber={15}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    
                                    {this.state.courseId === "custom" ?
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-sm-4">
                                                    <p className="sp-top10 text-right">
                                                        Test Name
                                                    </p>
                                                </div>
                                                <div className="col-sm-6">
                                                    <input className="form-control" type="text" value={this.state.name} onChange={e => this.setState({name: e.target.value})} />
                                                </div>
                                            </div>
                                        </div>
                                    : null}
                    
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <p className="sp-top10 text-right">
                                                    Status
                                                </p>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="sp-top10">
                                                    <div className="row">
                                                        <div className="col-sm-6">
                                                            <label><input type="radio" className="ichekRadioBtn TestTakeStatus" name="TestTakeStatus" value="false" checked={this.state.scored === false} onChange={e => this.setState({scored: false})}/> &nbsp; Voided</label>
                                                        </div>
                                                        <div className="col-sm-6">
                    
                                                            <label><input type="radio" className="ichekRadioBtn TestTakeStatus" name="TestTakeStatus" value="true" checked={this.state.scored === true} onChange={e => this.setState({scored: true})} /> &nbsp; Scored</label>
                                                        </div>
                                                    </div>
                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.scored &&
                                    <div className="testDetInfo">
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <p className="sp-top10 text-right">
                                                    Official Score
                                                </p>
                                            </div>
                                            <div className="col-sm-6">
                                                <input type="number" className="form-control" value={this.state.score} onChange={e => this.setState({score: e.target.value})} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="scoreBreakDown">
                                        <div className="row">
                                            <div className="col-sm-offset-4 col-sm-8">
                                                <h3 className="font-16 text-white">Score Breakdown</h3>
                                            </div>
                                        </div>
                                        
                                        {this.state.courseId === "custom" ?
                                            this.renderCustomTest()
                                        :
                                            <div className="form-group">
                                            
                                                {this.state.courseId && this.state.sections.length > 0 ?
                                                    this.state.sections.map((s, i) => this.renderTemplateSection(s, i))
                                                : null}
                                                
                                            </div>
                                        }
                                                            
                                                            
                                                            
                                        
                                                        </div>
                                    <div className="form-group">
                    
                                        <div className="row">
                                            <div className="col-sm-4">
                    
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="sp-top10">
                                                    <div className="row">
                                                        <div className="col-sm-12">
                                                            <label><input type="checkbox" className="ichekRadioBtn ScoreReleased" name="ScoreReleased" value="Yes" /> &nbsp; Score Not Released Yet</label>
                                                        </div>
                                                    </div>
                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="expectedScoreReleaseDate" style={{display: "none"}}>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-sm-4">
                                                    <p className="sp-top10 text-right">
                                                        Score Release Date
                                                    </p>
                                                </div>
                                                <div className="col-sm-6">
                                                    <input type="text" className="form-control" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                    }
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                                    <button type="button" className="btn btn-primary" onClick={e => this.saveTest()} data-dismiss="modal">Save changes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
    }
}

export default OfficialTest;


// WEBPACK FOOTER //
// ./src/components/Settings/OfficialTest.js